import { Component, OnInit} from '@angular/core';
import { CnafContacterMaCafService } from '../../../services/contactermacaf.service';
import { CnafAtTagService } from '@cnaf/ng-cnaf-commons';
import { Router } from '@angular/router';
import { TagXitiService } from '../../../services/tagxiti.service';
import { ContactermacafMotifsdecontactComponent } from '../../contactermacaf-motifsdecontact.component';
import {context} from '../../../../contexts/context';

@Component({
  selector: 'app-contactermacaf-motifsdecontact-delaisdetraitement',
  templateUrl: 'motifsdecontact-delaisdetraitement.component.html',
  styleUrls: ['../../contactermacaf-motifsdecontact.component.css']
})
export class MotifsdecontactDelaisDeTraitementComponent  extends ContactermacafMotifsdecontactComponent implements OnInit {


  constructor(
    private _router: Router,
    private _cnafContacterMaCafService: CnafContacterMaCafService,
    private _cnafAtTagService: CnafAtTagService,
    private _tagXitiService: TagXitiService
  ) {
    super(_router,_cnafContacterMaCafService);
  }

  ngOnInit(): void {
    this.chapitre3 = 'delai_traitement';
    super.ngOnInit();
  }

  consulterEnLigne(): void {
    const tagObj = this._tagXitiService.getAtTagObject(
      'btn_consulter_en_ligne',
       context.type,
      'contactermacaf',
      'svi_visuel_choix_motif',
      "delai_traitement"
    );
    tagObj.customPropsPersistent = {
      'svi_profil': this._tagXitiService.getProfilutilisateur()
    };
    this._cnafAtTagService.pageSend(tagObj);

    setTimeout(() => {
      window.location.href = '/redirect/s/Redirect?page=applimobileMonCompteDelaisTraitement';
    }, 300);
  }
}
